/* ============================================================
   ICONS — CuratedHomes' custom geometric line set (on-brand,
   editorial; not an off-the-shelf library). Ported from the
   prototype, now a shared ES module used app-wide.
   ============================================================ */

export const ICON_PATHS = {
  // primitives + brand glyphs (24x24, stroke)
  crosshair: (
    <>
      <circle cx="12" cy="12" r="7" />
      <line x1="12" y1="2" x2="12" y2="6" />
      <line x1="12" y1="18" x2="12" y2="22" />
      <line x1="2" y1="12" x2="6" y2="12" />
      <line x1="18" y1="12" x2="22" y2="12" />
    </>
  ),
  ring: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <circle cx="12" cy="12" r="3.5" />
    </>
  ),
  arc: (
    <>
      <path d="M4 20 A16 16 0 0 1 20 4" />
      <circle cx="20" cy="20" r="1.4" />
    </>
  ),
  nested: (
    <>
      <rect x="3.5" y="3.5" width="17" height="17" rx="1" />
      <rect x="8" y="8" width="8" height="8" rx="1" />
    </>
  ),
  node: (
    <>
      <circle cx="6" cy="6" r="2.4" />
      <circle cx="18" cy="18" r="2.4" />
      <line x1="7.6" y1="7.6" x2="16.4" y2="16.4" />
    </>
  ),
  circle: (
    <>
      <circle cx="12" cy="12" r="8.5" />
    </>
  ),
  dot: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <circle cx="12" cy="12" r="1.6" />
    </>
  ),
  square: (
    <>
      <rect x="4" y="4" width="16" height="16" rx="1.5" />
    </>
  ),
  diamond: (
    <>
      <rect x="6" y="6" width="12" height="12" rx="1" transform="rotate(45 12 12)" />
    </>
  ),
  triangle: (
    <>
      <path d="M12 4 L20.5 19 L3.5 19 Z" />
    </>
  ),
  plus: (
    <>
      <line x1="12" y1="4" x2="12" y2="20" />
      <line x1="4" y1="12" x2="20" y2="12" />
    </>
  ),
  cross: (
    <>
      <line x1="6" y1="6" x2="18" y2="18" />
      <line x1="18" y1="6" x2="6" y2="18" />
    </>
  ),
  hexagon: (
    <>
      <path d="M12 3 L20 7.5 L20 16.5 L12 21 L4 16.5 L4 7.5 Z" />
    </>
  ),
  arrowRight: (
    <>
      <line x1="4" y1="12" x2="20" y2="12" />
      <polyline points="14,6 20,12 14,18" />
    </>
  ),
  arrowUp: (
    <>
      <line x1="12" y1="20" x2="12" y2="4" />
      <polyline points="6,10 12,4 18,10" />
    </>
  ),
  chevron: (
    <>
      <polyline points="9,5 16,12 9,19" />
    </>
  ),
  layers: (
    <>
      <path d="M12 3 L21 8 L12 13 L3 8 Z" />
      <path d="M3 13 L12 18 L21 13" />
    </>
  ),
  grid: (
    <>
      <rect x="4" y="4" width="6.5" height="6.5" />
      <rect x="13.5" y="4" width="6.5" height="6.5" />
      <rect x="4" y="13.5" width="6.5" height="6.5" />
      <rect x="13.5" y="13.5" width="6.5" height="6.5" />
    </>
  ),
  door: (
    <>
      <rect x="6" y="3" width="12" height="18" rx="1" />
      <circle cx="14.5" cy="12" r="1" />
    </>
  ),
  mountain: (
    <>
      <path d="M3 19 L9.5 8 L13 14 L16 9 L21 19 Z" />
    </>
  ),
  key: (
    <>
      <circle cx="8" cy="8" r="4" />
      <line x1="11" y1="11" x2="20" y2="20" />
      <line x1="17" y1="20" x2="20" y2="17" />
    </>
  ),
  waveform: (
    <>
      <line x1="5" y1="9" x2="5" y2="15" />
      <line x1="10" y1="5" x2="10" y2="19" />
      <line x1="14" y1="8" x2="14" y2="16" />
      <line x1="19" y1="6" x2="19" y2="18" />
    </>
  ),
  asterisk: (
    <>
      <line x1="12" y1="4" x2="12" y2="20" />
      <line x1="5" y1="8" x2="19" y2="16" />
      <line x1="19" y1="8" x2="5" y2="16" />
    </>
  ),
  compass: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <polygon points="15,9 11,11 9,15 13,13" />
    </>
  ),
  feather: (
    <>
      <path d="M19 5 C12 5 6 11 6 18 L6 19" />
      <line x1="6" y1="14" x2="14" y2="14" />
      <path d="M19 5 C19 11 15 15 9 15" />
    </>
  ),
  eye: (
    <>
      <path d="M3 12 C6 7 18 7 21 12 C18 17 6 17 3 12 Z" />
      <circle cx="12" cy="12" r="2.5" />
    </>
  ),
  scale: (
    <>
      <line x1="12" y1="4" x2="12" y2="20" />
      <line x1="6" y1="20" x2="18" y2="20" />
      <path d="M5 9 L12 6 L19 9" />
      <path d="M3 13 A2.5 2.5 0 0 0 7 13" />
      <path d="M17 13 A2.5 2.5 0 0 0 21 13" />
    </>
  ),
  anchor: (
    <>
      <circle cx="12" cy="6" r="2.2" />
      <line x1="12" y1="8.2" x2="12" y2="20" />
      <path d="M5 13 A7 7 0 0 0 19 13" />
      <line x1="5" y1="13" x2="5" y2="11" />
      <line x1="19" y1="13" x2="19" y2="11" />
    </>
  ),
  // ui glyphs
  inbox: (
    <>
      <path d="M4 13 L8 13 L9.5 16 L14.5 16 L16 13 L20 13" />
      <path d="M4 13 L6 5 L18 5 L20 13 L20 19 L4 19 Z" />
    </>
  ),
  image: (
    <>
      <rect x="3.5" y="5" width="17" height="14" rx="1.5" />
      <circle cx="9" cy="10" r="1.8" />
      <path d="M5 18 L10 13 L14 16 L17 13 L19 15" />
    </>
  ),
  type: (
    <>
      <polyline points="5,7 5,5 19,5 19,7" />
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="9" y1="19" x2="15" y2="19" />
    </>
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M3.5 12 H20.5" />
      <path d="M12 3.5 C15 7 15 17 12 20.5 C9 17 9 7 12 3.5" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="6" />
      <line x1="15.5" y1="15.5" x2="20" y2="20" />
    </>
  ),
  shapes: (
    <>
      <circle cx="7" cy="8" r="3.5" />
      <rect x="13" y="13" width="7" height="7" rx="1" />
      <path d="M16.5 3 L20 9 L13 9 Z" />
    </>
  ),
  gauge: (
    <>
      <path d="M4 16 A8 8 0 0 1 20 16" />
      <line x1="12" y1="16" x2="16" y2="10" />
      <circle cx="12" cy="16" r="1.4" />
    </>
  ),
  back: (
    <>
      <line x1="20" y1="12" x2="4" y2="12" />
      <polyline points="10,6 4,12 10,18" />
    </>
  ),
  check: (
    <>
      <polyline points="5,12 10,17 19,6" />
    </>
  ),
  external: (
    <>
      <path d="M14 5 H19 V10" />
      <line x1="19" y1="5" x2="11" y2="13" />
      <path d="M17 14 V19 H5 V7 H10" />
    </>
  ),
  pen: (
    <>
      <path d="M16 4 L20 8 L9 19 L5 20 L6 16 Z" />
      <line x1="14" y1="6" x2="18" y2="10" />
    </>
  ),
  // social (line-style, on-brand with the geometric set)
  instagram: (
    <>
      <rect x="4" y="4" width="16" height="16" rx="4.5" />
      <circle cx="12" cy="12" r="3.6" />
      <circle cx="17" cy="7" r="1" />
    </>
  ),
  x: (
    <>
      <path d="M5 5 L19 19" />
      <path d="M19 5 L5 19" />
    </>
  ),
  facebook: (
    <>
      <path d="M14.5 8.5 V7 a1.5 1.5 0 0 1 1.5 -1.5 H17" />
      <path d="M11.5 21 V12 M9 12 H15" />
      <path d="M14.5 8.5 V21" />
    </>
  ),
}

export const ICON_NAMES = Object.keys(ICON_PATHS)

export function Icon({ name, size = 24, stroke = 1.5, className, style }) {
  const path = ICON_PATHS[name] || ICON_PATHS.circle
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {path}
    </svg>
  )
}
